<template>
  <v-container id="eixo-list">
    <v-row>
      <v-col class="col-values">
        <v-btn
          outlined
          color="primary"
          class="ml-3"
          @click="$router.push(`/gestao-territorios/${tabType}/0/edit`)"
          v-if="
            isFullAdmin ||
            (config.adicionarTerritorio && groupsConfig.adicionarTerritorio)
          "
        >
          Adicionar
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquise..."
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="values"
          class="elevation-1"
          hide-default-footer
          disable-pagination
          :search="search"
        >
          <template slot="no-data">
            <span> Nenhum Território </span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              outlined
              color="warning"
              class="mr-3"
              @click="
                $router.push(
                  `/gestao-territorios/${tabType}/${item.territorioId}/edit`
                )
              "
              v-if="
                isFullAdmin ||
                (config.editarTerritorio && groupsConfig.editarTerritorio)
              "
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>

            <v-btn
              outlined
              color="primary"
              class="mr-3"
              @click="
                $router.push(
                  `/gestao-territorios/${tabType}/${item.territorioId}/view`
                )
              "
              v-if="
                isFullAdmin ||
                (config.visualizarTerritorio &&
                  groupsConfig.visualizarTerritorio)
              "
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>

            <modalDelete
              :payload="item"
              @onDelete="load()"
              v-if="
                isFullAdmin ||
                (config.excluirTerritorio && groupsConfig.excluirTerritorio)
              "
            >
              <template v-slot:title> Editar Território </template>
            </modalDelete>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { territorioAPI } from "@/modules/gestao-territorios/API/territorioAPI";
import moment from "moment";

// import { governancaApi } from "../Api/governanca";
import modalDelete from "./modalDelete";

export default {
  components: {
    modalDelete,
  },
  computed: {
    ...mapGetters(["isFullAdmin", "config", "groupsConfig"]),
  },
  data() {
    return {
      headers: [
        { text: "Território", value: "nomeFantasia" },
        { text: "Início", value: "inicio" },
        { text: "Ações", value: "actions" },
      ],
      values: [],
      tabType: this.$route.params.tab,
      search: "",
    };
  },

  methods: {
    ...mapActions(["setLoading"]),
    load() {
      this.setLoading(true);
      territorioAPI.list().then(({ data }) => {
        this.values = data;
        this.values = data.map((item) => ({
          ...item,
          inicio: moment(item.inicio).format("DD/MM/YYYY"),
        }));
        this.setLoading(false);
      });
    },
  },

  mounted() {
    this.load();
  },
};
</script>
<style scoped lang="scss">
.col-values {
  display: flex;
  justify-content: flex-end;
}

.share-link {
  background: #5c8bb9 !important;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10%;
  width: 80%;
  .v-icon {
    color: #ffffff !important;
  }

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
      rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
      rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  }
}
</style>
